module.exports = __webpack_public_path__ + "static/media/fly.0f3d9fa0.png";